import React from "react"
import cn from "classnames"
import Field, { describedBy } from "./Field"
import styles from "../../styles/scss/components/form/formSystem.module.scss"

const Textarea = ({
    name,
    id = name,
    label,
    required,
    help,
    error,
    className,
    value,
    rows = 4,
    ...rest
}) => (
    <Field
        id={id}
        label={label}
        required={required}
        help={help}
        error={error}
        className={className}
    >
        <textarea
            id={id}
            name={name}
            rows={rows}
            value={value === null || value === undefined ? "" : value}
            required={required}
            aria-required={required || undefined}
            aria-invalid={error ? "true" : undefined}
            aria-describedby={describedBy(id, { help, error })}
            className={cn(styles.textarea)}
            {...rest}
        />
    </Field>
)

export default Textarea
